import {
  ADDRESSES_SEARCH,
  ADDRESSES_SEARCH_FULFILLED,
  ADDRESSES_SEARCH_REJECTED,
  CLEAR_ADDRESSES_SEARCH,
} from './actionTypes';
import {
  AddressesSearchType,
  ClearAddressesSearchAction,
  FetchAddressesSearchAction,
  FetchAddressesSearchFulfilledAction,
  FetchAddressesSearchRejectedAction,
} from './types';

const fetchAddressesSearch = (
  searchQuery: string,
): FetchAddressesSearchAction => ({
  type: ADDRESSES_SEARCH,
  payload: {
    searchQuery,
  },
});

const fetchAddressesSearchFulfilled = (
  response: AddressesSearchType,
): FetchAddressesSearchFulfilledAction => ({
  type: ADDRESSES_SEARCH_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchAddressesSearchRejected = (
  error: ErrorType,
): FetchAddressesSearchRejectedAction => ({
  type: ADDRESSES_SEARCH_REJECTED,
  payload: {
    error,
  },
});

const clearAddressesSearch = (): ClearAddressesSearchAction => ({
  type: CLEAR_ADDRESSES_SEARCH,
});

export {
  clearAddressesSearch,
  fetchAddressesSearch,
  fetchAddressesSearchFulfilled,
  fetchAddressesSearchRejected,
};
